import UseCase from './base';

export default abstract class Command<Param = void, Result = any> extends UseCase<Result, Param> {
  readonly = false;
}
